import { render, staticRenderFns } from "./PopUpGenerateReports.vue?vue&type=template&id=2428f66e&"
import script from "./PopUpGenerateReports.vue?vue&type=script&lang=ts&"
export * from "./PopUpGenerateReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2428f66e', component.options)
    } else {
      api.reload('2428f66e', component.options)
    }
    module.hot.accept("./PopUpGenerateReports.vue?vue&type=template&id=2428f66e&", function () {
      api.rerender('2428f66e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/BajasCobranza/PopUpGenerateReports.vue"
export default component.exports